import { render, staticRenderFns } from "./PageEnd.vue?vue&type=template&id=3300a851&scoped=true"
import script from "./PageEnd.vue?vue&type=script&lang=js"
export * from "./PageEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3300a851",
  null
  
)

export default component.exports